import React from 'react'
import img from "../../assets/Images/PageNotFound/404notfound.svg"

const PageNotFound = () => {

  return (
    <div className={`pt-[110px] pb-5 w-full h-full mx-auto`}>
        <img src={img} className='w-[40%] mx-auto' alt="" />
    </div>
  )
}

export default PageNotFound